import axios from 'axios';

// Base URL for Estabrook's own admin/backend API (estabrook-api), used for
// endpoints that need to land in the Estabrook system rather than this
// site's own backend.
const estabrookApiUrl = import.meta.env.VITE_ESTABROOK_API_URL || 'http://localhost:3000/';

const estabrookApi = axios.create({
	baseURL: estabrookApiUrl,
});

export { estabrookApi, estabrookApiUrl };
